import styled from 'styled-components'

const IndexStyle = styled.div`
  background: ${props => props.theme.background};
  display: flex;
  align-items: start;
  justify-content: center;
  min-height: 100vh;
  min-width: 1440px;

  .main {
    grid-area: main;
    display: flex;
    flex-direction: column;
  }
`
export default IndexStyle
